module.exports = __webpack_public_path__ + "img/Binguo2.9369ab74.jpg";